<template>
	<div :class="module.form_style">
		<module-form v-if="loaded && module" :module-data="loadedModuleData" :row="row" @saved="onSaved"></module-form>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import ModuleForm from './components/ModuleFormComponent';
import CrudForm from '@/mixins/CrudForm';
import RowTemplateBuilder from '@/utils/RowTemplateBuilder';

export default {

	mixins: [CrudForm],

	name: 'ModuleFormPage',

	async asyncData({ app, store, route, redirect }) {
		const isEditRoute = route.name === 'edit';
		const url = isEditRoute ? route.params.slug + '/' + route.params.id + '/edit'
			: route.params.slug + '/create';

		let data;
		try {
			const response = await app.$api.get(`/module/${url}`);
			data = response.data;
		} catch (e) {
			if (e.request && e.request.status === 404) {
				store.dispatch('addToast', { message: 'That entry has been deleted.', type: 'bad-bg' });
			} else {
				store.dispatch('errorToast', 'There was an issue loading that section');
			}

			return redirect(`/module/${route.params.slug}`);
		}

		if (isEditRoute && data.module.subtype === 'child') {
			const foreignIdField = data.module.parent.singular_table_name + '_id';
			return redirect(`/module/${ data.module.parent.slug }/${ data.row[foreignIdField]}/edit/${ data.module.slug }/${ data.row.id }`);
		}

		store.dispatch('setActiveModule', data.module);
		store.dispatch('setExtensions', data.extensions);

		return {
			loadedData: data,
			module: data.module,
		};
	},

	data() {
		return {
			loadedData: {},
			loadedModuleData: {},
			loaded: false,
			row: { isNew: true },
		};
	},

	computed: {

		isUpdate() {
			return this.$route.name === 'edit';
		},

	},

	created() {
		this.setData(this.loadedData);
	},

	methods: {
		setData({ module, tags, associatedModules, row }) {
			this.$store.dispatch('setActiveModule', module);
			this.loadedModuleData = {
				module, tags, associatedModules,
			};
			this.loaded = true;

			if (row) {
				this.row = row;
			}

			this.setLayout();
		},

		setLayout() {
			if (this.hasChildModules) {
				this.$store.commit('setHeaderButtons', [{ title: 'Go Back ', icon: 'fa fa-chevron-left', link: `${ this.module.url_path_prefix }${ this.module.slug }` }]);
			} else {
				this.$store.commit('setHeaderButtons', [{ title: 'Cancel', icon: 'fa-times', link: `${ this.module.url_path_prefix }${ this.$route.params.slug }` }]);
			}

			this.$store.commit('setPageData', {
				title: (this.isUpdate ? 'Edit ' : 'Add ') + this.module.singular_name,
				subtitle: RowTemplateBuilder.moduleRowValue(this.module, this.row),
				icon: this.module.icon,
			});
		},

		onSaved({ data }) {
			if (!this.hasChildModules) {
				return this.$router.push({ name: 'list', params: { slug: this.module.slug } });
			}

			if (!this.isUpdate) {
				return this.$router.replace({ name: 'edit', params: { slug: this.module.slug, id: data.id } });
			}
		},
	},

	components: {
		ModuleForm,
	},
};

</script>
